import { render, staticRenderFns } from "./CmgLoyaltyBannerRewardsPage.vue?vue&type=template&id=a0fed4c2&scoped=true&lang=pug"
import script from "./cmg-loyalty-banner-rewards-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-banner-rewards-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyBannerRewardsPage.vue?vue&type=style&index=0&id=a0fed4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fed4c2",
  null
  
)

export default component.exports